import { TaskElement } from "../schema";
import { ITaskController } from "../controller";
import { Group } from "react-konva";
import { ElementProps } from "elements/base/provider";
import consts from "shared/consts";
import { TASK_WIDTH, TASK_HEIGHT } from "shared/datamodel/task";
import { useTrackRenderCountForTests } from "utils/tests/use-track-render-count-for-tests";
import { ITraits, Trait } from "frontend/canvas-designer-new/elements-toolbar/elements-toolbar-types";
import { getFontSize } from "frontend/canvas-designer-new/text-element";
import useObservableController from "elements/hooks/use-observable-controller";
import { ExpandButton } from "./expand-button";
import { TaskWidgets } from "./widgets/task-widgets";
import { TaskTitle } from "./task-title";
import { TaskBackground } from "./task-background";
import Container from "frontend/ui-components/konva-helpers/container";
import { BORDER_HEIGHT, PADDING } from "../consts";

export default function TaskElementComponent({ controller: _controller }: ElementProps<TaskElement>) {
  useTrackRenderCountForTests(_controller.id);

  const controller = _controller as ITaskController;
  useObservableController(controller);

  const { element, context } = controller;
  const { width = TASK_WIDTH, height = TASK_HEIGHT } = element;

  return (
    <Container width={width} height={height + BORDER_HEIGHT}>
      <TaskBackground controller={controller} />

      {/* Content area */}
      <Group x={PADDING} y={PADDING}>
        <TaskTitle controller={controller} />
        <TaskWidgets controller={controller} />
        {!context.isReadOnly && <ExpandButton controller={controller} x={width - PADDING - 28} y={-4} />}
      </Group>
    </Container>
  );
}

export function taskTraits(element: TaskElement): ITraits {
  // We disable the traits when the task in inside a gantt chart.
  if (element.containerId?.startsWith("gantt")) {
    return {};
  }

  return {
    textColor: element.textColor ?? consts.DEFAULTS.TEXT_COLOR,
    fontProps: element.fontProps ?? 0,
    fontSize: getFontSize(element),
    font: element.font ?? consts.DEFAULTS.FONT,
    fillColor: element.fill,
  };
}

export function taskValidateTrait(_element: TaskElement, trait: Trait, value: unknown) {
  switch (trait) {
    default: {
      return value;
    }
  }
}
